import React from "react";
import { CONTACT_EMAIL, DEVELOPER_NAME } from "../data/apps";

export default function PrivacyPage() {
  return (
    <div className="container section prose">
      <h1>Privacy Policy</h1>
      <p className="muted">Last updated: October 2026</p>
      <p>
        This policy applies to the Android apps published by Northwind (
        {DEVELOPER_NAME}): Pokapoka, Motuner and Jerzey3D.
      </p>

      <h2>Information we collect</h2>
      <p>
        Northwind does not require an account and does not run its own servers
        for these apps. We do not collect your name, email address or location.
      </p>

      <h2>Your files and creations</h2>
      <p>
        Drawings, jersey designs, ROM (BIN) files and XDF definitions you open
        or create stay on your device. They are processed locally and are never
        uploaded to us. Files are only written to your device storage or
        gallery when you choose to save or export.
      </p>

      <h2>Advertising</h2>
      <p>
        The apps show ads using Google AdMob. AdMob may collect and use
        information such as your device's advertising ID, IP address and general
        device and usage data to serve and measure ads, and may show
        personalized ads depending on your settings and region. Where required
        (for example in the EEA and UK), the apps ask for your consent through
        Google's User Messaging Platform. You can reset your advertising ID or
        opt out of personalized ads in your Android settings. See{" "}
        <a
          href="https://policies.google.com/technologies/ads"
          target="_blank"
          rel="noreferrer"
        >
          how Google uses data from apps that use its services
        </a>
        .
      </p>

      <h2>Children</h2>
      <p>
        Our apps are not directed at children under 13 for the collection of
        personal information, and we do not knowingly collect any.
      </p>

      <h2>Changes</h2>
      <p>
        We may update this policy from time to time. The latest version is
        always available on this page.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about this policy? Email{" "}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>
    </div>
  );
}
